import { render, staticRenderFns } from "./server-attach-volume.vue?vue&type=template&id=4947e77f&scoped=true&"
import script from "./server-attach-volume.vue?vue&type=script&lang=js&"
export * from "./server-attach-volume.vue?vue&type=script&lang=js&"
import style0 from "./server-attach-volume.vue?vue&type=style&index=0&id=4947e77f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947e77f",
  null
  
)

export default component.exports